import React, { FC } from 'react';
import { Accordion, Icon, Icons } from '@silverfort/sf-components';

interface Props {
    mitigationDescription: string;
    reference?: { link: string; desc: string };
}

const InsightMitigation: FC<Props> = ({ mitigationDescription, reference }) => {
    const onLinkClicked = () => {
        if (reference) {
            window.open(reference.link);
        }
    };

    return (
        <Accordion
            style={{ boxShadow: 'none', borderRadius: '16px' }}
            sx={{
                '& .MuiAccordionSummary-content': { margin: 0 },
                '& .MuiButtonBase-root.Mui-expanded': { height: 30, minHeight: 30 },
                '& .MuiButtonBase-root': { height: 30, minHeight: 30 },
                '& .MuiAccordionDetails-root': { paddingBottom: 0, paddingTop: '16px' }
            }}
            className="w-full border py-4"
            summary={<div className="w-full text-13 font-sf font-medium">Recommended Mitigation</div>}
            accordionSummaryProps={{
                expandIcon: <Icon icon={Icons.ChevronDown} size={16} />
            }}
            accordionDetailsProps={{}}>
            <div className="w-full flex flex-col gap-[16px]">
                <div className="max-h-[190px] overflow-y-auto text-12 text-sf-gray-500 font-sf whitespace-break-spaces">
                    {mitigationDescription}
                </div>
                {reference && (
                    <div className="h-full flex items-center gap-[4px]">
                        <div className="text-13 text-sf-gray-400 font-sf">Reference</div>
                        <div className="text-12 text-sf-gray-400 font-sf">|</div>
                        <div
                            className="text-13 text-sf-primary-500 font-sf font-medium cursor-pointer"
                            onClick={onLinkClicked}>
                            {reference.desc}
                        </div>
                    </div>
                )}
            </div>
        </Accordion>
    );
};

export default InsightMitigation;
